import { LegalLayout, H2, P, Strong, UL, LI, Table } from "@/components/legal/LegalLayout";

const PrivacyPage = () => (
  <LegalLayout
    title="Politique de confidentialité"
    subtitle="Dernière mise à jour : 26 août 2026"
  >
    <P>
      Cette politique explique comment SelfieBooth Event collecte, utilise et protège vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.
    </P>

    <H2>1. Responsable du traitement</H2>
    <P>
      <Strong>SelfieBooth Event</Strong> — Walid Bourahla<br />
      44B rue Gabriel Péri, 78210 Saint-Cyr-l&apos;École<br />
      Email : <a href="mailto:walid.societe.pro@gmail.com" style={{ color: "#B8977E" }}>walid.societe.pro@gmail.com</a><br />
      Téléphone : 06 79 39 34 29
    </P>

    <H2>2. Données collectées</H2>
    <P><Strong>Lors d&apos;une demande de devis ou d&apos;une réservation :</Strong></P>
    <UL>
      <LI>Nom et prénom</LI>
      <LI>Adresse email</LI>
      <LI>Numéro de téléphone</LI>
      <LI>Adresse et lieu de l&apos;événement</LI>
      <LI>Date et type d&apos;événement</LI>
      <LI>Message libre (facultatif)</LI>
    </UL>
    <P><Strong>Automatiquement lors de la navigation (avec votre consentement) :</Strong></P>
    <UL>
      <LI>Adresse IP</LI>
      <LI>Type de navigateur et système d&apos;exploitation</LI>
      <LI>Pages visitées et durée de visite</LI>
      <LI>Source d&apos;arrivée (référent)</LI>
      <LI>Données publicitaires Meta (si consentement)</LI>
    </UL>

    <H2>3. Finalités et bases légales du traitement</H2>
    <Table
      head={["Donnée", "Finalité", "Base légale"]}
      rows={[
        ["Nom, email, téléphone, adresse", "Traiter votre demande, exécuter la prestation", "Exécution du contrat"],
        ["Adresse IP + horodatage signature", "Traçabilité juridique du devis signé", "Obligation légale"],
        ["Données analytiques (Google Analytics)", "Améliorer le site", "Consentement"],
        ["Données publicitaires (Meta Pixel)", "Mesurer et optimiser la publicité", "Consentement"],
        ["Email", "Envoi ponctuel de promotions", "Consentement (opt-in)"],
      ]}
    />

    <H2>4. Durée de conservation</H2>
    <UL>
      <LI>Données client (contrat) : 10 ans à compter de la fin de la prestation (obligation comptable et fiscale)</LI>
      <LI>Prospects (devis non signés) : 3 ans à compter du dernier contact</LI>
      <LI>Cookies analytiques (Google Analytics) : 13 mois maximum</LI>
      <LI>Cookies publicitaires (Meta Pixel) : 13 mois maximum</LI>
      <LI>Emails commerciaux : jusqu&apos;à désinscription</LI>
    </UL>

    <H2>5. Destinataires des données</H2>
    <P>Vos données sont traitées par :</P>
    <UL>
      <LI>Walid Bourahla, en qualité de responsable du traitement</LI>
      <LI>Hébergeur du site : Emergent (transfert vers les États-Unis encadré par les clauses contractuelles types de la Commission européenne)</LI>
      <LI>Meta Platforms Ireland Ltd (si consentement publicitaire) — transfert de données vers les États-Unis encadré par les clauses contractuelles types</LI>
      <LI>Google LLC (si consentement analytique) — transfert encadré par le Data Privacy Framework</LI>
    </UL>
    <P><Strong>Vos données ne sont jamais vendues à des tiers.</Strong></P>

    <H2>6. Vos droits</H2>
    <P>Conformément au RGPD, vous disposez des droits suivants :</P>
    <UL>
      <LI>Droit d&apos;accès : obtenir une copie de vos données</LI>
      <LI>Droit de rectification : corriger vos données inexactes</LI>
      <LI>Droit à l&apos;effacement : demander la suppression de vos données</LI>
      <LI>Droit à la limitation : restreindre le traitement de vos données</LI>
      <LI>Droit à la portabilité : recevoir vos données dans un format structuré</LI>
      <LI>Droit d&apos;opposition : vous opposer au traitement de vos données</LI>
      <LI>Droit de retirer votre consentement à tout moment</LI>
    </UL>
    <P><Strong>Pour exercer vos droits, contactez :</Strong> <a href="mailto:walid.societe.pro@gmail.com" style={{ color: "#B8977E" }}>walid.societe.pro@gmail.com</a></P>
    <P>Nous nous engageons à répondre dans un délai maximum d&apos;un mois.</P>

    <H2>7. Réclamation</H2>
    <P>Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL :</P>
    <UL>
      <LI>Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: "#B8977E" }}>www.cnil.fr</a></LI>
      <LI>Adresse : 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07</LI>
    </UL>

    <H2>8. Sécurité</H2>
    <P>Nous mettons en œuvre des mesures techniques et organisationnelles adaptées pour protéger vos données : chiffrement HTTPS de toutes les communications, accès restreint aux données par l&apos;équipe autorisée, sauvegardes régulières, hébergement sécurisé.</P>

    <H2>9. Modifications</H2>
    <P>Cette politique peut être modifiée à tout moment pour refléter les évolutions légales ou fonctionnelles du site. La date de dernière mise à jour est indiquée en haut de la page.</P>
  </LegalLayout>
);

export default PrivacyPage;
